module.exports = __webpack_public_path__ + "static/media/Pegasus.814889c9.png";